import { useRef as s, useEffect as e } from "../external/preact/hooks/dist/hooks.js";
const t = () => {
  const t = s(null);
  return e(() => {
    t.current?.focus();
  }, []), t;
};
export { t as default };
